module.exports = __webpack_public_path__ + "img/icons B_27.478396b8.png";